module.exports = __webpack_public_path__ + "img/114.7626912b.png";